import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {CodaltComponent} from '../codalt/codalt.component';
import {MatDialogRef} from '@angular/material/dialog';
import {DIALOG_DATA} from '@angular/cdk/dialog';
import {Ttm} from '../../classes/ttm';

@Component({
    selector: 'app-ttm-svg-viewer',
    templateUrl: './ttm-svg-viewer.component.html',
    styleUrl: './ttm-svg-viewer.component.scss'
})
export class TtmSvgViewerComponent extends CodaltComponent implements OnInit {

    ttms: Ttm[];

    constructor(
        public dialogRef: MatDialogRef<TtmSvgViewerComponent>,
        @Inject(DIALOG_DATA) public data: { ttms: Ttm[], currentImage: Ttm }) {
        super();
    }

    ngOnInit(): void {
        const index = this.data.ttms.indexOf(this.data.currentImage);
        const images = this.data.ttms;
        this.ttms = [...images.slice(index, images.length), ...images.slice(0, index)];
    }

    @HostListener('click', ['$event'])
    public click(event) {
        if (event.target.localName !== 'img'
            && event.srcElement.className.indexOf('wiper-zoom-container') !== -1) {
            this.dialogRef.close();
        }
    }
}
